import { Policy } from "@shared/models/policy";
import { BankAccount } from "../../BankAccount";
import { Address } from "./Address";

export enum PaymFormEnum {
    'ADDRESS' = 1,
    'BANKACCOUNT' = 2
}

export type PaymFormType = {
    id: number,
    name: string,
};

export class PaymForm {

    private availablePaymForm: Array<PaymFormType> = [];

    constructor(
        private policy: Policy,
        private address: Address
    ) {

        (Object.keys(PaymFormEnum)
            .map((key: string) => PaymFormEnum[key])
            .filter(value => typeof value === 'number'))
            .forEach(value => {
                this.availablePaymForm.push({
                    id: value,
                    name: PaymFormEnum[value]
                } as PaymFormType);

            });

        // Fixed issue 27
        /*if (this.policy.bankAccount.length == 0) {
          delete this.availablePaymForm[PaymFormEnum.BANKACCOUNT];
        }*/

        // chqr 29
        this.availablePaymForm.sort((a, b) => b.id - a.id);

        if (this.address == null) {
            delete this.availablePaymForm[PaymFormEnum.ADDRESS];
        }

    }

    get values() {
        return this.availablePaymForm;
    }

    getLabel(paymForm: string): string {

        switch (PaymFormEnum[paymForm]) {
            case PaymFormEnum.ADDRESS:
                return 'policy.storno.form.address';
            case PaymFormEnum.BANKACCOUNT:
                return 'policy.storno.form.account';
            default:
                return '';
        }
    }

    getChoices(paymForm: string) {
        switch (PaymFormEnum[paymForm]) {
            case PaymFormEnum.ADDRESS:
                return this.formatAddress();
            case PaymFormEnum.BANKACCOUNT:
                return Object.values(this.policy.bankAccount).map((value: BankAccount) => value.account);
            default:
                return '';
        }
    }

    private formatAddress(): string {

        let adr = '';

        adr += (this.address.name ? this.address.name : '') + ' ' + (this.address.surname ? this.address.surname : '') + ', ';
        adr += (this.address.addressResponse.street ? this.address.addressResponse.street : '') + ' ';
        adr += ((this.address.addressResponse.descriptiveNumber != null) ?
            this.address.addressResponse.descriptiveNumber :
            (this.address.addressResponse.registrationNumber ? this.address.addressResponse.registrationNumber : '')) + ', ';
        adr += (this.address.addressResponse.zip ? this.address.addressResponse.zip : '') + ' ';
        adr += (this.address.addressResponse.city ? this.address.addressResponse.city : '');

        return adr;
    }
}

